import { memo, useMemo } from 'react';

import { useRole } from 'hooks/useRole';

import Typography from 'components/UI/Typography/Typography';

import { RULES } from 'components/config/rewardSystem';

import styles from './HowItWorks.module.scss';

const HowItWorks = () => {
  const role = useRole();

  const itemsJSX = useMemo(
    () =>
      RULES.howItWorks[role]?.map(({ title, description, Icon }) => (
        <div key={title} className={styles.item}>
          <Icon className={styles.icon} />
          <div className={styles.text}>
            <Typography weight="semibold" color="blue">
              {title}
            </Typography>
            <Typography color="grey">{description}</Typography>
          </div>
        </div>
      )),
    [role],
  );

  return (
    <div className={styles.root}>
      <Typography type="text-lg" weight="medium" uppercase>
        How it works
      </Typography>
      <div className={styles.items}>{itemsJSX}</div>
    </div>
  );
};

export default memo(HowItWorks);
